import "./style.scss";

const VerticalLine = () => {
  return <div className="default-vertical-line"></div>;
};

export default VerticalLine;
